import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import WithNotifications from 'components/shared/notifications'
import { actions as TrackingActions } from 'app/modules/tracking'
import { fetchMicrosoftAdminConsent, fetchMicrosoftManagedCalendars } from 'app/modules/meetings/actions'
import { hasMicrosoftAdminConsent, getMicrosoftAdminConsentUsers, hasFetchedMicrosoftAdminConsent } from 'app/modules/meetings/selectors'

import ConnectedCalendars from './ConnectedCalendars'
import ConnectGlobalCalendar from './ConnectGlobalCalendar'

class GlobalCalendarSettings extends Component {
  
  constructor(props) {
    super(props)
    this.state = {
      isConnected: props.isGlobalCalendarConnected
    }
  }

  async componentDidMount () {
    await this.props.actions.fetchMicrosoftAdminConsent()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isGlobalCalendarConnected !== this.props.isGlobalCalendarConnected) {
      this.setState({ isConnected: this.props.isGlobalCalendarConnected, pending: false })
    }
  }

  trackEvent = (name, attributes) => {
    this.props.actions.track(name, {
      context: 'settings',
      service: 'microsoft-admin-consent',
      ...attributes,
    })
  }

  onCalendarConnected = () => {
    const { track, fetchMicrosoftManagedCalendars } = this.props.actions

    this.setState({ isConnected: true }, () => {
      this.props.notifications.success('Your Office 365 calendars are successfully connected.')
      track('Admin consent given', { context: 'settings' })
      this.trackEvent('Admin Consent Setup', { action: 'connected' })
    }, fetchMicrosoftManagedCalendars)
  }

  onCalendarConnectFailed = () => {
    this.setState({ isConnected: false }, () => {
      this.props.notifications.error('Failed to get admin consent. Please review your Office 365 app permissions.')
    })
  }

  onCalendarDisconnect = () => {
     const { track } = this.props.actions

    this.setState({ isConnected: false }, () => {
      this.props.notifications.success('Your Office 365 calendars have been successfully disconnected.')
      track('Admin consent disconnected', { context: 'settings' })
      this.trackEvent('Admin Consent Setup', { action: 'disconnected' })
    })
  }

  render() {
    const { isConnected } = this.state
    const { hasFetchedConsentStatus } = this.props

    if (!hasFetchedConsentStatus)
      return null

    return (
      <div className="settings-global-calendar">
        { !isConnected &&
          <ConnectGlobalCalendar onConnected={this.onCalendarConnected} onConnectFailed={this.onCalendarConnectFailed}/>
        }
        { isConnected &&
           <ConnectedCalendars onDisconnect={this.onCalendarDisconnect}/>
        }
      </div>
    )
  }

}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchMicrosoftAdminConsent,
      track: TrackingActions.track,
      fetchMicrosoftManagedCalendars
    },
    dispatch
  ),
})

const mapStateToProps = state => ({
  isGlobalCalendarConnected: hasMicrosoftAdminConsent(state),
  hasFetchedConsentStatus: hasFetchedMicrosoftAdminConsent(state),
  globalCalendarUsers: getMicrosoftAdminConsentUsers(state)
})

export default WithNotifications(connect(mapStateToProps, mapDispatchToProps)(GlobalCalendarSettings))



// WEBPACK FOOTER //
// ./src/scripts/components/settings/GlobalCalendarSettings/index.js